import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: 'if-stale',
      retry: (n, err) => ![401, 403, 404].includes(err?.status) && n < 1,
    },
  },
});

export const queryKeys = {
  feed: (limit, filters = {}) => ['pages', 'feed', limit, filters],
  article: (id, userId = null) => ['pages', 'article', id, userId],
  alerts: (limit, userId = null, filters = {}) => [
    'pages',
    'alerts',
    limit,
    userId,
    filters,
  ],
  profile: (userId = null) => ['pages', 'profile', userId],
  adminDashboard: () => ['pages', 'admin', 'dashboard'],
  adminContent: (status, q = '') => ['pages', 'admin', 'content', status, q],
  adminSources: () => ['pages', 'admin', 'sources'],
  adminNewsAgent: () => ['admin', 'news-agent', 'status'],
  adminAlerts: (filters) => ['pages', 'admin', 'alerts', filters],
  adminUsers: (filters) => ['admin', 'users', filters],
  adminAnalyticsOverview: (range) => ['admin', 'analytics', 'overview', range],
  adminAnalyticsArticles: (range, sort) => [
    'admin',
    'analytics',
    'articles',
    range,
    sort,
  ],
  adminAnalyticsArticle: (id, range) => [
    'admin',
    'analytics',
    'article',
    id,
    range,
  ],
  adminAnalyticsAlerts: (range) => ['admin', 'analytics', 'alerts', range],
  adminAnalyticsAudience: (range) => ['admin', 'analytics', 'audience', range],
  adminAnalyticsOps: (range) => ['admin', 'analytics', 'ops', range],
};

/** After content/alert mutations, refresh every screen that shows those numbers. */
export function invalidateAfterContentChange(client) {
  return Promise.all([
    client.invalidateQueries({ queryKey: ['pages', 'admin', 'content'] }),
    client.invalidateQueries({ queryKey: queryKeys.adminDashboard() }),
    client.invalidateQueries({ queryKey: ['pages', 'feed'] }),
    client.invalidateQueries({ queryKey: ['pages', 'article'] }),
    client.invalidateQueries({ queryKey: ['admin', 'analytics'] }),
  ]);
}

export function invalidateAfterAlertChange(client) {
  return Promise.all([
    client.invalidateQueries({ queryKey: ['pages', 'alerts'] }),
    client.invalidateQueries({ queryKey: ['pages', 'admin', 'alerts'] }),
    client.invalidateQueries({ queryKey: queryKeys.adminDashboard() }),
  ]);
}
